module.exports = __webpack_public_path__ + "img/newsList.a890285e.png";